<template>
    <div
        v-if="show"
        class="container"
    >
        <h3>{{ $translate('compare_cards_compare_to_similar_cards', 'Jämför mot liknande kort') }}</h3>

        <div class="card-slider">
            <div class="card-slider__inner">
                <card
                    :id="document.id"
                    :current-card="document.id"
                />

                <card
                    v-for="id in idsToCompare"
                    :id="id"
                    :key="id"
                />
            </div>
        </div>

        <div class="button">
            <nuxt-link
                :to="compareRoute"
                class="btn btn-md btn-green-border"
            >
                {{ $translate('compare_cards_make_a_complete_comparison', 'Gör en komplett jämförelse') }}
            </nuxt-link>
        </div>
    </div>
</template>

<script>
import Card from '@/components/card/CardCompare.vue';
export default {
    components: { Card },
    props: {
        document: {
            type: Object,
            required: true,
            default: () => {}
        },
        model: {
            type: Object,
            required: true,
            default: () => {}
        }
    },
    computed: {
        idsToCompare() {
            return this.document.data.cards
                .map(iterator => iterator.card)
                .filter(card => card.id && !card.isBroken)
                .map(card => card.id);
        },
        show() {
            return this.idsToCompare.length > 0;
        },

        // TODO: Hard coded url and kort parameter
        compareRoute() {

            let route = this.$isSweden() ? '/jamfor/' : '/sammenlign/';

            route = `${route}?card=${this.document.id}`;
            for (let i = 0; i < this.idsToCompare.length; i++) {
                route += `&card=${this.idsToCompare[i]}`;
            }
            return route;
        }
    }
};
</script>

<style lang="scss" scoped>
    .container {
        width: 100%;
        position: relative;
        @media screen and (max-width: 750px) {}

        .overlay {
            position: absolute;
            right: -20px;
            top: -20px;
            background: linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 100%);
            height: calc(100% + 40px);
            width: 80px;
        }

        .card-count {
            @include spacing(margin,8,top);
            @include flex(end);
            .btn:last-child { margin-left: 10px; }
        }

        h3 {
            // margin-bottom: 50px!important;
        }

        .card-slider {
            width: 100%;
            overflow: auto;
            padding: 10px 20px 20px 0;

            &__inner {
                gap: 20px;
                display: flex;

                .card-compare {
                    // margin-right: 20px;
                    // min-width: calc(33% - 40px);
                    min-width: 240px;
                    &:last-child { margin-right: 100px; }
                }
            }
        }

        .button {
            @include flex;
            @include device(pad) {
                justify-content: flex-end;
            }
            .btn {
                margin-top: 20px;
            }
        }
    }
</style>
